/* ============================================================
   INDIGREY REDESIGN — COLLECTION runtime
   Card swipe + arrows + segments, once-per-session swipe hint,
   filter/sort dropdown, AJAX Section-Rendering filter/sort/category.
   ============================================================ */
(function () {
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- card image gallery (native scroll-snap, COS mechanism) ----------
     The track scrolls itself: arrows call scrollBy() and the indicators follow
     the real scroll position, so swipe, arrow and momentum all resolve through
     one source of truth instead of a separate JS drag handler. */
  function scrollerOf(card) { return card.querySelector('[data-ig-scroller]'); }
  function slideCount(card) {
    var sc = scrollerOf(card);
    return sc ? sc.children.length : 0;
  }
  function currentIndex(card) {
    var sc = scrollerOf(card);
    if (!sc || !sc.clientWidth) return 0;
    return Math.round(sc.scrollLeft / sc.clientWidth);
  }
  /* Arrow presence: first frame has no Previous, last frame has no Next.
     Toggled via opacity + pointer-events so the arrows never move — hiding
     them with display would reflow the control and shift the layout. */
  function setArrowShown(el, shown) {
    if (!el) return;
    el.classList.toggle('is-hidden', !shown);
    el.setAttribute('aria-hidden', shown ? 'false' : 'true');
    el.tabIndex = shown ? 0 : -1;
  }
  function updateArrowState(card, idx, n) {
    setArrowShown(card.querySelector('.ig-rd-card__arrow--l'), idx > 0);
    setArrowShown(card.querySelector('.ig-rd-card__arrow--r'), idx < n - 1);
  }

  /* Adaptive contrast, sampled per arrow against the frame it actually sits on.
     The rects mirror the arrows' CSS position (left/right edge, vertically
     centred) rather than using whole-image brightness, so an arrow over a
     bright highlight inside a dark photo still reads. Only `stroke` is ever
     written — never fill, opacity, width or shape. */
  var ARROW_RECT = { l: [0.00, 0.40, 0.14, 0.60], r: [0.86, 0.40, 1.00, 0.60] };
  function paintArrow(card, side, url) {
    var el = card.querySelector('.ig-rd-card__arrow--' + side);
    if (!el || !url || !window.IG || !window.IG.regionBrightness) return;
    var svg = el.querySelector('svg');
    if (!svg) return;
    window.IG.regionBrightness(url, ARROW_RECT[side], function (lum) {
      var prev = el.getAttribute('data-arrow-tone') || null;
      var next = window.IG.arrowColor(lum, prev);
      if (next === prev) return;              // no write unless it truly changes
      el.setAttribute('data-arrow-tone', next);
      svg.style.stroke = next;                // CSS transitions this slowly
    });
  }
  function paintArrows(card, idx) {
    var sc = scrollerOf(card);
    if (!sc) return;
    var slide = sc.children[idx];
    var img = slide && slide.querySelector('img');
    var url = img && (img.currentSrc || img.src);
    if (!url) return;
    paintArrow(card, 'l', url);
    paintArrow(card, 'r', url);
  }

  function syncIndicators(card) {
    var idx = currentIndex(card);
    var n = slideCount(card);
    if (String(idx) !== card.getAttribute('data-img-idx')) {
      card.setAttribute('data-img-idx', idx);
      if (window.IG) window.IG.paintCardIcons(card, { skipArrows: true });
      updateArrowState(card, idx, n);
      paintArrows(card, idx);
    }
    card.querySelectorAll('.ig-rd-card__seg').forEach(function (s, i) {
      s.classList.toggle('is-on', i === idx);
    });
  }
  function stepCard(card, dir) {
    var sc = scrollerOf(card);
    var n = slideCount(card);
    if (!sc || n < 2) return;
    // Clamp rather than wrap: with the end arrows hidden there is no affordance
    // for wrapping, and swipe cannot wrap either — the two must agree.
    var next = Math.min(n - 1, Math.max(0, currentIndex(card) + dir));
    if (next === currentIndex(card)) return;
    // scroll-behavior:smooth on the element animates this; assigning
    // scrollLeft keeps the wrap-around jump instant rather than racing back
    // through every slide.
    {
      var target = next * sc.clientWidth;
      var from = sc.scrollLeft;
      sc.scrollTo({ left: target, behavior: REDUCED ? 'auto' : 'smooth' });
      // Smooth scrolling is animated by the compositor and can be dropped
      // entirely when the tab is throttled — leaving the arrow looking dead.
      // If nothing has moved shortly after the request, land the scroll
      // directly so the control is never a no-op.
      setTimeout(function () {
        if (Math.abs(sc.scrollLeft - from) < 1 && Math.abs(sc.scrollLeft - target) >= 1) {
          var prevB = sc.style.scrollBehavior;
          sc.style.scrollBehavior = 'auto';
          sc.scrollLeft = target;
          sc.style.scrollBehavior = prevB || '';
          syncIndicators(card);
        }
      }, 350);
    }
    syncIndicators(card);
  }
  function initCards(root) {
    (root || document).querySelectorAll('.ig-rd-card').forEach(function (card) {
      if (card.__igCardInit) return; card.__igCardInit = true;
      var sc = scrollerOf(card);
      var l = card.querySelector('.ig-rd-card__arrow--l');
      var r = card.querySelector('.ig-rd-card__arrow--r');
      if (l) l.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); stepCard(card, -1); });
      if (r) r.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); stepCard(card, 1); });
      if (sc) {
        updateArrowState(card, currentIndex(card), sc.children.length);
        paintArrows(card, currentIndex(card));
        // rAF-throttled: scroll fires continuously during a swipe
        var ticking = false, settle = null;
        sc.addEventListener('scroll', function () {
          // rAF keeps the indicator live during the gesture...
          if (!ticking) {
            ticking = true;
            requestAnimationFrame(function () { ticking = false; syncIndicators(card); });
          }
          // ...and a settle pass guarantees the final resting slide is synced,
          // since the last rAF can be dropped when frames stop being produced
          // (throttled tab, or momentum ending between frames).
          clearTimeout(settle);
          settle = setTimeout(function () { syncIndicators(card); }, 120);
        }, { passive: true });
        // a swipe must not be treated as a tap-through to the product page
        var sx = null;
        sc.addEventListener('pointerdown', function (e) { sx = e.clientX; }, { passive: true });
        sc.addEventListener('click', function (e) {
          if (sx !== null && Math.abs(e.clientX - sx) > 8) { e.preventDefault(); e.stopPropagation(); }
          sx = null;
        }, true);
      }
    });
  }

  /* ---------- once-per-session swipe hint (first card) ---------- */
  function swipeHint() {
    if (REDUCED || !window.sessionStorage) return;
    var force = window.location.search.indexOf('swipeDemo') !== -1;
    if (sessionStorage.getItem('indigrey_swipe_hint_played') && !force) return;
    if (!force) sessionStorage.setItem('indigrey_swipe_hint_played', '1');
    // The track scrolls natively now, so the hint nudges scrollLeft rather than
    // transforming an image — same prototype rhythm (-14px, three times), but
    // it demonstrates the real gesture the user is meant to perform.
    var firstCard = document.querySelector('.ig-rd-grid .ig-rd-card');
    var sc = firstCard && firstCard.querySelector('[data-ig-scroller]');
    if (!sc || sc.children.length < 2) return;
    var timers = [];
    function set(v) { sc.scrollTo({ left: Math.max(0, v), behavior: 'smooth' }); }
    function cancel() { timers.forEach(clearTimeout); timers = []; set(0); detach(); }
    function detach() {
      window.removeEventListener('touchstart', cancel, true);
      window.removeEventListener('pointerdown', cancel, true);
      window.removeEventListener('wheel', cancel, true);
    }
    window.addEventListener('touchstart', cancel, true);
    window.addEventListener('pointerdown', cancel, true);
    window.addEventListener('wheel', cancel, true);
    [[500, 14], [750, 0], [1000, 14], [1250, 0], [1500, 14], [1750, 0]]
      .forEach(function (p) { timers.push(setTimeout(function () { set(p[1]); }, p[0])); });
    timers.push(setTimeout(detach, 1850));
  }

  /* ---------- filter/sort dropdown ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-ig-filter-trigger]');
    if (trigger) {
      e.preventDefault(); e.stopPropagation();
      trigger.closest('[data-ig-filter]').classList.toggle('is-open');
      return;
    }
    var closer = e.target.closest && e.target.closest('[data-ig-filter-close]');
    if (closer) { closer.closest('[data-ig-filter]').classList.remove('is-open'); return; }
  });

  /* ---------- AJAX filter / sort / category ---------- */
  function sectionRoot() { return document.querySelector('.ig-rd-collection[data-section-id]'); }
  function mergeSort(sortVal) {
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sortVal);
    u.searchParams.delete('page');
    return u.pathname + '?' + u.searchParams.toString();
  }
  var loading = false;
  function navAjax(url) {
    var root = sectionRoot();
    if (!root || loading) { window.location.href = url; return; }
    loading = true;
    root.classList.add('is-loading');
    var sid = root.getAttribute('data-section-id');
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid);
    fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshInner = doc.querySelector('.ig-rd-collection__inner');
        var curInner = root.querySelector('.ig-rd-collection__inner');
        if (freshInner && curInner) curInner.innerHTML = freshInner.innerHTML;
        // update the supporting count line (noun changes per category tab),
        // fading it so the switch reads smoothly
        var count = root.querySelector('.ig-rd-grid');
        var head = document.querySelector('[data-ig-heading-count]') || document.querySelector('.ig-rd-heading__count');
        if (count && head) {
          var label = count.getAttribute('data-count-label') || 'Styles';
          var next = (count.getAttribute('data-count') || '0') + ' ' + label;
          if (head.textContent.trim() !== next) {
            head.classList.add('is-swapping');
            setTimeout(function () { head.textContent = next; head.classList.remove('is-swapping'); }, 180);
          }
        }
        // update URL
        try { window.history.pushState({}, '', url); } catch (e) {}
        document.dispatchEvent(new CustomEvent('ig-rd:grid-updated'));
        initCards(root);
      })
      .catch(function () { window.location.href = url; })
      .finally(function () { loading = false; root.classList.remove('is-loading'); });
  }
  document.addEventListener('click', function (e) {
    var sortEl = e.target.closest && e.target.closest('[data-sort]');
    if (sortEl) { e.preventDefault(); e.stopPropagation(); closeFilter(); navAjax(mergeSort(sortEl.getAttribute('data-sort'))); return; }
    var urlEl = e.target.closest && e.target.closest('[data-ajax-url]');
    if (urlEl) { e.preventDefault(); e.stopPropagation(); closeFilter(); navAjax(urlEl.getAttribute('data-ajax-url')); return; }
  });
  function closeFilter() { document.querySelectorAll('[data-ig-filter].is-open').forEach(function (f) { f.classList.remove('is-open'); }); }

  window.addEventListener('popstate', function () { navAjax(window.location.pathname + window.location.search); });

  /* ---------- boot ---------- */
  function boot() { initCards(document); swipeHint(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
